import { enums } from "@shared/constants";
import { SHOWPASS_CREDIT_TYPES } from "@shared/constants/enums";
import { t, useTranslation } from "@shared/utils/internationalization";
import { TicketBasketType } from "../types";

export const getIsAutoDiscount = (discount: TicketBasketType["discount"]) =>
  discount?.type === enums.DISCOUNT_TYPES.DISC_TYPE_AUTO_APPLIED.id;

export const getIsMembershipBenefitDiscount = (
  discount: TicketBasketType["discount"]
) => discount?.type === enums.DISCOUNT_TYPES.DISC_TYPE_MEMBERSHIP.id;

export const getIsTicketCredit = (discount: TicketBasketType["discount"]) =>
  discount?.type === enums.DISCOUNT_TYPES.DISC_TYPE_VOUCHER_CREDIT.id;

export const getDiscountApplication = (
  discount: TicketBasketType["discount"]
) => {
  if (discount?.apply_method === enums.APPLY_TYPE_MAP.APPLY_TO_EACH.id)
    return t("off per item");

  if (discount?.apply_method === enums.APPLY_TYPE_MAP.APPLY_ONCE.id)
    return t("off entire order");

  return undefined;
};

export const getDiscountLimit = (discount: TicketBasketType["discount"]) => {
  return (
    discount?.per_user_limit &&
    `${t("max")} ${discount?.per_user_limit} ${t("per item")}`
  );
};

export const getCreditLabels = (isApplied?: boolean, creditType?: string) => {
  const { t } = useTranslation("discounts");

  const isGiftCard = creditType === SHOWPASS_CREDIT_TYPES.GIFT_CARD_CREDIT.id;
  const isExchangeCredit =
    creditType === SHOWPASS_CREDIT_TYPES.EXCHANGE_CREDIT.id;

  // Determine credit type text
  let creditTypeText = "credit";
  if (isGiftCard) {
    creditTypeText = "gift card credit";
  } else if (isExchangeCredit) {
    creditTypeText = "exchange credit";
  }

  // Determine prefix based on application status
  const prefix = isApplied ? "Applied" : "Available";
  const actionPrefix = isApplied ? "remove" : "apply";

  // Construct the labels
  const appliedText = t(`${prefix} ${creditTypeText}`);
  const ariaLabel = t(`${actionPrefix} ${creditTypeText}`);
  const testId = `${actionPrefix}-${creditTypeText.replace(/\s+/g, "-")}`;

  return { appliedText, ariaLabel, testId };
};
